module.exports = __webpack_public_path__ + "static/img/bg-tr.1d6daf47.png";